export default __webpack_public_path__ + "assets/images/11.b44f12.png";